import * as alerts from './alerts'

export { alerts }
